import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { translate as t } from '../../lib/I18n';
import Button from 'react-bootstrap/lib/Button';

import Icon from '../general/Icon';
import PureRenderComponent from '../PureRenderComponent';

class StepperInput extends PureRenderComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        labelSide: PropTypes.oneOf([ 'left', 'right' ]),
        value: PropTypes.number,
        min: PropTypes.number,
        max: PropTypes.number,
        onChange: PropTypes.func,
        error: PropTypes.string
    };

    static defaultProps = {
        name: '',
        label: '',
        labelSide: 'left',
        value: 0,
        min: 0,
        max: 9,
        onChange: _.noop,
        error: ''
    };

    _makeIncrement = ({ value, min, max, onChange }) => () => {
        if (value >= min && value < max) {
            const newValue = value + 1;
            onChange(newValue);
        }
    };

    _makeDecrement = ({ value, min, max, onChange }) => () => {
        if (value > min && value <= max) {
            const newValue = value - 1;
            onChange(newValue);
        }
    };

    _renderLabel ({ name, label }) {
        if (label) {
            return (
                <label className="sr-only" htmlFor={ name }>
                    { label }
                </label>
            );
        }

        return null;
    }

    render () {
        const { label, name, value, error } = this.props;

        return (
            <div className={
                classnames('stepper', {
                    [name]: true,
                    'stepper--error': this.props.error
                }) }>
                <Button className="stepper--decrement pull-left" onClick={ this._makeDecrement(this.props) }>
                    <Icon icon="remove" />
                    <span className="sr-only">
                        { `${error}. ` }{ t('ariaLabel.stepperInput', { label, value, direction: 'Remove' }) }
                    </span>
                </Button>

                <div className="stepper__faux-input pull-left">
                    <span className="stepper__number text-weight--normal">{ value }</span> { label }
                </div>

                { this._renderLabel(this.props) }

                <Button bsStyle="default" className="stepper--increment pull-left" onClick={ this._makeIncrement(this.props) }>
                    <Icon icon="add" />
                    <span className="sr-only">
                        { `${error}. ` }{ t('ariaLabel.stepperInput', { label, value, direction: 'Add' }) }
                    </span>
                </Button>
            </div>
        );
    }
}

export default StepperInput;



// WEBPACK FOOTER //
// ./src/components/form/StepperInput.js